import { linkToClassroomCourse } from "../../links";

export function linkToRecommendedSessionForCourse(courseId?: string) {
  return `${linkToClassroomCourse(courseId)}/new-session`;
}
